import React from 'react';
import '../styles/contact.css'

const Contact = () => {
    return (
        <div className='contact'>
            <h1>Contact Juan Carlos</h1>
            <h2>juanca943005@gmail.com</h2>
        </div>
    );
};

export default Contact;